import Vue from 'vue'
import axios from 'axios'
import {ACCESS_TOKEN} from '../store/mutation-types'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/mq', // api base_url
  timeout: 16000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    switch (error.response.status) {
      case 501:
        alert('登录已过期,请重新登录')
        console.log('501异常')
        break
      case 500:
        console.log('500异常')
        break
      // eslint-disable-next-line no-fallthrough
      case 404:
        console.log('404异常')
        break
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers[ 'access-token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

service.interceptors.response.use((response) => {
  return response.data
}, err)

export {
  service as axios
}



// WEBPACK FOOTER //
// ./src/utills/request.js